import styled from "@emotion/styled";
import { Box, Theme } from "@mui/material";

export const PagesBox = styled(Box)<{ theme: Theme }>((props) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  margin: props.theme.spacing(1),
}));

export const ChildContainer = styled(Box)<{ theme: Theme, disable?: boolean }>((props) => ({
    padding: props.theme.spacing(2),
    textAlign: 'center',
    cursor: props.disable ? 'inherit' : 'pointer',
    color: props.disable ? props.theme.palette.text.disabled : 'inherit',
    '& svg': {
        color: props.theme.palette.secondary.main,
    },
    '&:not(:nth-child(2n))': {
        borderRight: `2px solid ${props.theme.palette.divider}`,
    },
    '&:not(:nth-last-child(-n + 2))': {
        borderBottom: `2px solid ${props.theme.palette.divider}`,
    },
}));

export const ModalContainer = styled(Box)<{theme: Theme}>((props) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  backgroundColor: props.theme.palette.background.paper,
  border: '2px solid gray',
  boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  padding: 4,
  '& .MuiFormControl-root': {
    marginBottom: props.theme.spacing(1),
  }
}));